/** Keep the loading cards aligned with the live carousel at every breakpoint. */
export const AGENT_PORTFOLIO_SECTION_CLASS =
	'w-full border-b border-white-dark-3 bg-white py-8 [--portfolio-end-gutter:var(--portfolio-gutter)] [--portfolio-gutter:20px] md:py-12 md:[--portfolio-gutter:32px] lg:[--portfolio-end-gutter:0px] lg:[--portfolio-gutter:48px] xl:[--portfolio-gutter:max(128px,calc((100vw-1440px)/2))]';

export const AGENT_PORTFOLIO_ITEM_CLASS =
	'basis-[calc((100%-var(--portfolio-gutter)-var(--portfolio-end-gutter))*0.9)] first:ml-[var(--portfolio-gutter)] last:mr-[var(--portfolio-end-gutter)] sm:basis-[calc((100%-var(--portfolio-gutter)-var(--portfolio-end-gutter)-20px)/2)] lg:basis-[calc(100%-var(--portfolio-gutter))] xl:basis-[calc((100%-var(--portfolio-gutter)-20px)/2)]';

export const AGENT_PORTFOLIO_VIEWPORT_CLASS =
	'overflow-hidden! md:overflow-hidden! ml-[calc(-1*var(--portfolio-gutter))] w-[calc(100%+var(--portfolio-gutter)+var(--portfolio-end-gutter))]';

export const AGENT_PORTFOLIO_CARD_FOOTER_CLASS =
	'h-auto min-h-[129px] md:min-h-[114px]';
